import { Link } from 'react-router-dom';
import { hotMatches } from '@/mocks/matches';

export default function HotMatches() {
  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门赛事
            </h2>
            <p className="mt-2 text-sm text-foreground-500">实时追踪全球最受关注的体育赛事</p>
          </div>
          <Link
            to="/category/football"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {hotMatches.map((match) => (
            <div
              key={match.id}
              className="bg-background-50 border border-background-200 rounded-xl p-5 hover:border-primary-300 transition-all duration-200 cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs text-foreground-500 bg-background-100 px-2.5 py-1 rounded-full">{match.league}</span>
                {match.status === 'live' && (
                  <span className="flex items-center gap-1.5 text-xs text-red-500 font-medium">
                    <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                    直播中 {match.time}
                  </span>
                )}
                {match.status === 'upcoming' && (
                  <span className="text-xs text-accent-600 font-medium bg-accent-50 px-2.5 py-1 rounded-full">{match.time} 开赛</span>
                )}
                {match.status === 'finished' && (
                  <span className="text-xs text-foreground-400">已结束</span>
                )}
              </div>

              <div className="flex items-center justify-between py-3">
                <div className="flex flex-col items-center gap-2 flex-1">
                  <div className="w-12 h-12 rounded-full bg-background-100 flex items-center justify-center">
                    <i className="ri-shield-line text-foreground-400 text-xl"></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-900 text-center">{match.homeTeam}</span>
                </div>

                <div className="px-4">
                  {match.status !== 'upcoming' ? (
                    <div className="flex items-center gap-2">
                      <span className="text-2xl font-heading font-bold text-foreground-950">{match.homeScore}</span>
                      <span className="text-foreground-400 text-lg">:</span>
                      <span className="text-2xl font-heading font-bold text-foreground-950">{match.awayScore}</span>
                    </div>
                  ) : (
                    <span className="text-lg font-heading font-bold text-foreground-400">VS</span>
                  )}
                </div>

                <div className="flex flex-col items-center gap-2 flex-1">
                  <div className="w-12 h-12 rounded-full bg-background-100 flex items-center justify-center">
                    <i className="ri-shield-line text-foreground-400 text-xl"></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-900 text-center">{match.awayTeam}</span>
                </div>
              </div>

              <div className="mt-4 pt-3 border-t border-background-200 flex justify-center">
                <Link
                  to={`/category/${match.category}`}
                  className="text-xs text-primary-500 hover:text-primary-600 cursor-pointer whitespace-nowrap"
                >
                  查看赛事详情 →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}